import Product from '@/creditflowresearch/domain/Product/Product';
import Segment from '@/creditflowresearch/domain/Segment';
import { ProductType, ProductAbbreviations } from '@/creditflowresearch/domain/Product/types/ProductType';
import { CORPORATE_SEGMENTS } from '@/creditflowresearch/domain/Segment/constants';
import {
  LM_PRODUCT_ID,
  LM_ABBREVIATION,
  LM_TYPE,
} from '@/creditflowresearch/domain/Product/constants';
import { EMERGING_MARKET_ID } from '@/creditflowresearch/domain/Market/constants';

class LmProduct extends Product {
  static readonly PRODUCT_ID: string = LM_PRODUCT_ID;

  static readonly ABBREVIATION: ProductAbbreviations = LM_ABBREVIATION;

  static readonly TYPE: ProductType = LM_TYPE;

  getDefaultProductId(accessibleProductIds: string[] = []): string {
    return accessibleProductIds.length > 0 ? this.id : this.id;
  }

  getDefaultForContext(): Product | null {
    return LmProduct.getDefault();
  }

  getMarketIds(): string[] {
    return [EMERGING_MARKET_ID];
  }

  getSegments(): Segment[] {
    return CORPORATE_SEGMENTS.map((type) => Segment.from(type)).filter(
      (segment): segment is Segment => segment !== null,
    );
  }

  static getDefault(): Product | null {
    return Product.from(LM_PRODUCT_ID);
  }
}

export default LmProduct;
